import { apiGet } from "./apiClient";
import { registerSessionReset, assertSessionCurrent, sessionIsCurrent, sessionTicket } from '../../../../utils/sessionLifecycle';

const requestCache = new Map();
registerSessionReset(() => requestCache.clear());

export function normalizeCanonicalPartOption(row) {
  const id = Number(row?.id ?? row?.value);
  if (!Number.isInteger(id) || id <= 0) return null;
  return {
    id,
    value: id,
    part_key: row.part_key || null,
    name: row.name || row.label || "",
    label: row.label || row.name || "",
    aliases: Array.isArray(row.aliases) ? row.aliases.map(alias => ({
      label: alias?.label || "",
      implied_side: alias?.implied_side || null,
    })).filter(alias => alias.label) : [],
  };
}

export function fetchCanonicalPartOptions({ search = "", includeId = null, limit = 100 } = {}) {
  const ticket = sessionTicket();
  const params = new URLSearchParams();
  if (search.trim()) params.set("search", search.trim());
  if (includeId != null) params.set("include_id", String(includeId));
  params.set("limit", String(limit));
  const path = `/parts-v1/options?${params.toString()}`;
  if (!requestCache.has(path)) {
    requestCache.set(path, apiGet(path)
      .then(res => {
        assertSessionCurrent(ticket);
        if (!res.data?.success) throw Object.assign(new Error(res.data?.message || "Could not load parts."), { code: res.data?.code });
        return (res.data?.data?.rows || []).map(normalizeCanonicalPartOption).filter(Boolean);
      })
      .finally(() => { if (sessionIsCurrent(ticket)) requestCache.delete(path); }));
  }
  return requestCache.get(path);
}

export function matchingPartAlias(option, search) {
  const normalized = String(search || "").trim().toLocaleLowerCase();
  if (!normalized) return null;
  return (option?.aliases || []).find(alias => alias.label.trim().toLocaleLowerCase() === normalized) || null;
}
